/* eslint-disable no-param-reassign */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-await-in-loop */
import { ObjectAccess } from 'components/storage/types/object';
import { ActionCreator, AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { ErrorObj, IResponse } from 'services/api/axios';
import profileService from 'services/api/customer/profile-service';
import storageService from 'services/api/customer/storage-service';
import i18n from 'services/i18n';
import { RootState } from 'store';
import { notificationActions } from 'store/notification';
import { NotifyVariant } from 'store/notification/types';
import { ActionTypes } from 'store/storage/types';

export const setIsActive: ActionCreator<AnyAction> = (payload: boolean | null) => ({
  type: ActionTypes.SET_IS_ACTIVE,
  payload,
});
export const setLoading: ActionCreator<AnyAction> = (payload: boolean) => ({
  type: ActionTypes.SET_LOADING,
  payload,
});
export const setError: ActionCreator<AnyAction> = (payload: string | null) => ({
  type: ActionTypes.SET_ERROR,
  payload,
});
export const startUpload: ActionCreator<AnyAction> = (payload: File[]) => ({
  type: ActionTypes.START_UPLOAD,
  payload,
});
export const setProgress: ActionCreator<AnyAction> = (payload: number) => ({
  type: ActionTypes.SET_PROGRESS,
  payload,
});
export const stopUpload: ActionCreator<AnyAction> = () => ({
  type: ActionTypes.STOP_UPLOAD,
});
export const setUploadError: ActionCreator<AnyAction> = (payload: string) => ({
  type: ActionTypes.SET_UPLOAD_ERROR,
  payload,
});

export type ThunkStorageDispatch = ThunkDispatch<RootState, void, AnyAction>;

export const getHasAccess = () => async (
  dispatch: ThunkStorageDispatch,
) => {
  dispatch(setLoading(true));
  dispatch(setError(null));
  try {
    const res = await profileService.getIsStorageEnabled();
    // const isParentUser = getState().user.isRootUser;
    dispatch(setIsActive(res.data));
  } catch (err: any) {
    const errors = err.response?.data?.errors as IResponse['errors'];
    dispatch(setError(errors?.map((errorObj) => errorObj.message).join(', ') || i18n.t('notification.error')));
    dispatch(setIsActive(false));
  } finally {
    dispatch(setLoading(false));
  }
};

export const startUploadFiles = (
  bucketKey: string,
  acl: ObjectAccess,
  files: File[],
) => async (dispatch: ThunkStorageDispatch, getState: () => RootState) => {
  dispatch(startUpload(files.sort((a, b) => a.size - b.size)));
  dispatch(setProgress(0));

  const progressStep = Math.floor(100 / files.length);
  const onbeforeunloadHandler = (event: BeforeUnloadEvent) => {
    event.preventDefault();
    event.returnValue = true;
  };
  window.addEventListener('beforeunload', onbeforeunloadHandler);
  for (const file of files) {
    const dto = new FormData();
    dto.append('file', file);
    if (getState().storage.uploading.progress !== null) {
      try {
        await storageService.uploadFile(bucketKey, acl, dto);
        dispatch(setProgress((getState().storage.uploading.progress || 0) + progressStep));
      } catch (err: any) {
        const errors = err.response.data.errors as ErrorObj[];
        if (errors?.some((error: { code: number }) => error.code === 6)) {
          dispatch(setUploadError('6'));
          window.onbeforeunload = null;
          return;
        }

        errors?.forEach(({ message }) => {
          dispatch(notificationActions.add({
            variant: NotifyVariant.Error,
            message,
          }));
        });

        if (errors === undefined) {
          dispatch(notificationActions.add({
            variant: NotifyVariant.Error,
            message: i18n.t('notification.error'),
          }));
        }
        dispatch(stopUpload());
        window.removeEventListener('beforeunload', onbeforeunloadHandler);
        return;
      }
    } else {
      dispatch(stopUpload());
      break;
    }
  }
  window.removeEventListener('beforeunload', onbeforeunloadHandler);
  dispatch(notificationActions.add({
    variant: NotifyVariant.Success,
    message: i18n.t('storage.file_uploading_success'),
  }));
  dispatch(stopUpload());
};
